import { z } from 'zod';
import { dateLike } from '@/schemas/field-schemas';

export const searchSchema = z.object({
  ngay_ct1: dateLike.optional(),
  ngay_ct2: dateLike.optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),

  ngay_giao: dateLike.optional(),
  status: z.string().optional(),
  mau_bc: z.number().optional(),
  loai_don_hang: z.string().optional(),
  dien_giai: z.string().optional(),
  ma_unit: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;
export const initialValues: SearchFormValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',

  ngay_giao: new Date().toISOString().split('T')[0],
  status: '0',
  mau_bc: 10,
  loai_don_hang: '0',
  dien_giai: '',
  ma_unit: ''
};
